module.exports = __webpack_public_path__ + "img/ico-option.6329f40a.svg";